import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReduxProject } from '@Hooks/reduxProjectHook/useReduxProject';
import { useReduxLeads } from '@Hooks/reduxLeadsHook/useReduxLeads';
import SnackbarManager from '@CommonFunctionalDisplay/GlobalSnackbar/SnackbarManager';
import WhatsappOAuthService from '@Helpers/URLHelpers/WeboutService/WhatsappOAuthService';
import ErrorHandler from '@Root/ErrorHandler';
import './FacebookOAuthCallBack.scss';

const FacebookOAuthCallBack = () => {

    const navigate = useNavigate();
    const { currentProjectId } = useReduxProject();
    const { setCurrentLeads } = useReduxLeads();
    const whatsappOAuthService = new WhatsappOAuthService();
    const errorHandler = new ErrorHandler();

    useEffect(() => {
        renderData();
    }, []);

    const renderData = () => {
        const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        if (!code) {
            const error = params.get('error');
            SnackbarManager.show(error, 'error');
            window.history.replaceState({}, '', cleanUrl);
            navigate('/home');
        } else {
            connectWhatsapp(code);
        }
    }

    const connectWhatsapp = async(code)=> {
        const cleanUrl = window.location.origin + window.location.pathname + window.location.hash;
        try {
            let bodyObj = {
                code: code,
                projectId: currentProjectId
            }
            let response = await whatsappOAuthService.connectWhatsapp(bodyObj);
            if(response.status == 200) {
                SnackbarManager.show(response.message, 'success');
                response = JSON.parse(response.body);
                let list = response.leadsList;
                if(!!list && list.length >= 1) {
                    setCurrentLeads(list[0]);
                    window.history.replaceState({}, '', cleanUrl);
                    navigate('/home/whatsapp');
                }
            } else {
                window.history.replaceState({}, '', cleanUrl);
                SnackbarManager.show(response.message, 'error');
            }
        } catch(err) {
            errorHandler.handleError(err);
            window.history.replaceState({}, '', cleanUrl);
            navigate('/home/whatsapp');
        }
    }

    return (
        <div className="kzq-whatsapp-callback-container">
            <div className="kzq-whatsapp-callback-card">
                <div className="kzq-whatsapp-callback-loader"></div>
                <h2 className="kzq-whatsapp-callback-title">Connecting WhatsApp...</h2>
                <p className="kzq-whatsapp-callback-desc">Please wait while we connect your WhatsApp account. This may take a few seconds.</p>
            </div>
        </div>
    );
};

export default FacebookOAuthCallBack;
